import appConfig from "../config/appConfig";

export const getApiUrl = () => appConfig("REACT_APP_API_URL");



// WEBPACK FOOTER //
// ./src/helpers/apiUrlHelpers.js